<template>
  <!-- 工单详情 -->
  <div class="order-detail">
    <courseCleanKeeping v-if="moduleKey == 'courseCleanKeeping'" ref="courseCleanKeeping"></courseCleanKeeping>
    <courseEquipmentInspection
      v-if="moduleKey == 'courseEquipmentInspection'"
      ref="courseEquipmentInspection"
    ></courseEquipmentInspection>
    <courseComprehensiveInspection
      v-if="moduleKey == 'courseComprehensiveInspection'"
      ref="courseComprehensiveInspection"
    ></courseComprehensiveInspection>
    <courseEquipmentMaintenance
      v-if="moduleKey == 'courseEquipmentMaintenance'"
      ref="courseEquipmentMaintenance"
    ></courseEquipmentMaintenance>
    <courseUsecar v-if="moduleKey == 'courseUsecar'" ref="courseUsecar"></courseUsecar>
    <courseComplaints v-if="moduleKey == 'courseComplaints'" ref="courseComplaints"></courseComplaints>
    <courseEscort v-if="moduleKey == 'courseEscort'" ref="courseEscort"></courseEscort>
    <courseRepair v-if="moduleKey == 'courseRepair'" ref="courseRepair"></courseRepair>
    <courseRepairInformation
      v-if="moduleKey == 'courseRepairInformation'"
      ref="courseRepairInformation"
    ></courseRepairInformation>
    <courseRepairLogistics
      v-if="moduleKey == 'courseRepairLogistics'"
      ref="courseRepairLogistics"
    ></courseRepairLogistics>
    <courseSecurity v-if="moduleKey == 'courseSecurity'" ref="courseSecurity"></courseSecurity>
    <courseTransport v-if="moduleKey == 'courseTransport'" ref="courseTransport"></courseTransport>
    <courseAreaInspection
      v-if="moduleKey == 'courseAreaInspection'"
      ref="courseAreaInspection"
    ></courseAreaInspection>
  </div>
</template>

<script>
import courseCleanKeeping from '@/views/crmedical/order/order-list/course-cleanKeeping'; //保洁服务
import courseEquipmentInspection from '@/views/crmedical/order/order-list/course-equipment-inspection'; //设备巡检
import courseEquipmentMaintenance from '@/views/crmedical/order/order-list/course-equipment-maintenance'; //设备维保服务
import courseUsecar from '@/views/crmedical/order/order-list/course-usecar'; //用车服务
import courseComplaints from '@/views/crmedical/order/order-list/course-complaints'; //投诉监督
import courseEscort from '@/views/crmedical/order/order-list/course-escort'; //陪护服务
import courseRepair from '@/views/crmedical/order/order-list/course-repair'; //报修服务
import courseRepairInformation from '@/views/crmedical/order/order-list/course-repair-information'; //报修服务-信息设备维修
import courseRepairLogistics from '@/views/crmedical/order/order-list/course-repair-logistics'; //报修服务-医疗设备维修
import courseSecurity from '@/views/crmedical/order/order-list/course-security'; //保安服务
import courseTransport from '@/views/crmedical/order/order-list/course-transport'; //运送服务
import courseAreaInspection from '@/views/crmedical/order/order-list/course-area-inspection'; //区域巡检
import courseComprehensiveInspection from '@/views/crmedical/order/order-list/course-comprehensive-inspection'; //综合巡检

import { getOrderListApi } from '@/api/call-system';

export default {
  name: 'Orderdetail',
  props: ['orderInfo'],
  components: {
    courseCleanKeeping,
    courseEquipmentInspection,
    courseEquipmentMaintenance,
    courseUsecar,
    courseComplaints,
    courseEscort,
    courseRepair,
    courseSecurity,
    courseTransport,
    courseAreaInspection,
    courseComprehensiveInspection,
    courseRepairInformation,
    courseRepairLogistics,
  },
  data() {
    return {
      orderDetail: null, // 工单详情
      moduleKey: '', // 当前的工单类型标识
    };
  },
  methods: {
    /* 父组件调用此方法触发显示弹窗 */
    show() {
      this.moduleKey = '';
      // 根据工单编号获取工单列表，得到当前工单号对应的条目详情
      let arr = this.orderInfo.orderCode.split('-'); // 数据格式为：code-projectId
      getOrderListApi({
        projectId: arr[1],
        code: arr[0],
        current: 1,
        size: 1,
      }).then(({ data }) => {
        this.orderDetail = data.records[0];
        this.openCourse(this.orderDetail, 'detail');
      });
    },
    /* 打开工单详情弹窗 */
    openCourse(row, type) {
      /* type取值: 1-保洁服务 2-保安服务 3-陪护服务 4-运送服务 5-投诉监督 6-用车服务 7-报修服务 8-设备维保服务 9-设备巡检 10-区域巡检 */
      switch (parseInt(row.moduleType)) {
        case 1:
          this.moduleKey = 'courseCleanKeeping';
          setTimeout(() => {
            this.$refs.courseCleanKeeping.getDictionary().then(() => {
              this.$refs.courseCleanKeeping.openDialog(row);
            });
          });
          break;
        case 2:
          this.moduleKey = 'courseSecurity';
          setTimeout(() => {
            this.$refs.courseSecurity.getDictionary().then(() => {
              this.$refs.courseSecurity.openDialog(row);
            });
          });
          break;
        case 3:
          this.moduleKey = 'courseEscort';
          setTimeout(() => {
            this.$refs.courseEscort.getDictionary().then(() => {
              this.$refs.courseEscort.openDialog(row);
            });
          });
          break;
        case 4:
          this.moduleKey = 'courseTransport';
          setTimeout(() => {
            this.$refs.courseTransport.getDictionary().then(() => {
              this.$refs.courseTransport.openDialog(row);
            });
          });
          break;
        case 5:
          this.moduleKey = 'courseComplaints';
          setTimeout(() => {
            this.$refs.courseComplaints.getDictionary().then(() => {
              this.$refs.courseComplaints.openDialog(row);
            });
          });
          break;
        case 6:
          this.moduleKey = 'courseUsecar';
          setTimeout(() => {
            this.$refs.courseUsecar.getDictionary().then(() => {
              this.$refs.courseUsecar.openDialog(row);
            });
          });
          break;
        case 7:
          this.moduleKey = 'courseRepair';
          setTimeout(() => {
            this.$refs.courseRepair.getDictionary().then(() => {
              if (type == 'edit') {
                this.$refs.courseRepair.openDialog(row, true);
              } else {
                this.$refs.courseRepair.openDialog(row, false);
              }
            });
          });
          break;
        case 8:
          this.moduleKey = 'courseEquipmentMaintenance';
          setTimeout(() => {
            this.$refs.courseEquipmentMaintenance.getDictionary().then(() => {
              this.$refs.courseEquipmentMaintenance.openDialog(row);
            });
          });
          break;
        case 9:
          this.moduleKey = 'courseEquipmentInspection';
          setTimeout(() => {
            this.$refs.courseEquipmentInspection.getDictionary().then(() => {
              this.$refs.courseEquipmentInspection.openDialog(row);
            });
          });
          break;
        case 10:
          this.moduleKey = 'courseAreaInspection';
          setTimeout(() => {
            this.$refs.courseAreaInspection.getDictionary().then(() => {
              this.$refs.courseAreaInspection.openDialog(row.id);
            });
          });
          break;
        case 11:
          this.moduleKey = 'courseComprehensiveInspection';
          setTimeout(() => {
            this.$refs.courseComprehensiveInspection.getDictionary().then(() => {
              let obj = Object.assign({}, row);
              obj.orderId = row.id;
              this.$refs.courseComprehensiveInspection.openDialog(obj);
            });
          });
          break;
        case 12:
          this.moduleKey = 'courseRepairInformation';
          setTimeout(() => {
            this.$refs.courseRepairInformation.getDictionary().then(() => {
              if (type == 'edit') {
                this.$refs.courseRepairInformation.openDialog(row, true);
              } else {
                this.$refs.courseRepairInformation.openDialog(row, false);
              }
            });
          });
          break;
        case 13:
          this.moduleKey = 'courseRepairLogistics';
          setTimeout(() => {
            this.$refs.courseRepairLogistics.getDictionary().then(() => {
              if (type == 'edit') {
                this.$refs.courseRepairLogistics.openDialog(row, true);
              } else {
                this.$refs.courseRepairLogistics.openDialog(row, false);
              }
            });
          });
          break;
      }
    },
  },
};
</script>
